import * as React from 'react';
import classnames from 'classnames';

import styles from './error-page.less';
import { PageFooterContainer } from '../page-footer/page-footer';

export type ErrorPageType =
    | 'not-found'
    | 'system-down'
    | 'expired-link'
    | 'desktop-only'
    | 'estimate-no-longer-exits';

export const ErrorPage: React.SFC<{ type: ErrorPageType }> = ({ type }) => {
    let imgName: string;
    let title: string;
    let subtitle: string;
    if (type === 'not-found') {
        imgName = 'hotAirBalloon';
        title = 'Uh-oh you’re lost';
        subtitle = 'We can’t seem to find the page you’re looking for.';
    } else if (type === 'system-down') {
        imgName = 'systemDown';
        title = 'It’s not you, it’s us. We’re having system issues.';
        subtitle = 'Stay tuned, we’ll be back shortly.';
    } else if (type === 'estimate-no-longer-exits') {
        imgName = 'hotAirBalloon';
        title = 'This estimate no longer exists';
        subtitle = '';
    } else if (type === 'expired-link') {
        imgName = 'stopwatch';
        title = 'Whoops';
        subtitle = 'This link has expired';
    } else if (type === 'desktop-only') {
        imgName = 'hotAirBalloon';
        title = 'Want to see a list of your invoices?';
        subtitle =
            'Click the link in your email on your desktop to view all invoices and make a payment.';
    } else {
        throw `Invalid type ${type}`;
    }

    return (
        <div className={classnames('page', styles.page)}>
            <div className={classnames('page-content', styles.pageContent)}>
                <img
                    src={`/assets/images/${imgName}.png`}
                    srcSet={`/assets/images/${imgName}.png, /assets/images/${imgName}@2x.png 2x, /assets/images/${imgName}@3x.png 3x`}
                />
                <div className={styles.title}>{title}</div>
                <div className={styles.subtitle}>{subtitle}</div>
            </div>
            <div className="space-filler" />
            <PageFooterContainer />
        </div>
    );
};
